import { lazy } from "react";

const WorkStatusLD = lazy(() => import("../Component/ManageLeads/WorkStatusLD"));
const SelfAdded = lazy(() => import("../Component/Leads/SelfAdded"));
const Picked = lazy(() => import("../Component/Leads/Picked"));
const CommonLeads = lazy(() => import("../Component/Leads/CommonLeads"));
const Fresh = lazy(() => import("../Component/Leads/Fresh"));
const Working = lazy(() => import("../Component/Leads/Working"));
const Interested = lazy(() => import("../Component/Leads/Interested"));
const Doable = lazy(() => import("../Component/Leads/Doable"));
const UnderReview = lazy(() => import("../Component/Leads/UnderReview"));
const Sanction = lazy(() => import("../Component/Leads/Sanction"));
const CouldnotConnected = lazy(() => import("../Component/Leads/CouldnotConnected"));
const Disbursed = lazy(() => import("../Component/Leads/Disbursed"));
const LoggedIn = lazy(() => import("../Component/Leads/LoggedIn"));

const statusRoutes = [
  { path: "/work-status-leads", element: <WorkStatusLD />, protected: true },
  { path: "/self-added-leads", element: <SelfAdded />, protected: true },
  { path: "/picked-leads", element: <Picked />, protected: true },
  { path: "/common-leads", element: <CommonLeads />, protected: true },
  { path: "/assigned-leads", element: <Fresh />, protected: true },
  { path: "/working-leads", element: <Working />, protected: true },
  { path: "/interested-leads", element: <Interested />, protected: true },
  { path: "/doable-leads", element: <Doable />, protected: true },
  { path: "/under-review-leads", element: <UnderReview />, protected: true },
  { path: "/sanction-leads", element: <Sanction />, protected: true },
  { path: "/could-not-connected-leads", element: <CouldnotConnected />, protected: true },
  { path: "/disbursed-leads", element: <Disbursed />, protected: true },
  { path: "/logged-in-leads", element: <LoggedIn />, protected: true },
];

export default statusRoutes;
